<template>
  <div class="card">
    <div class="card-body">
      <div id="invoiceDetailsContainer" class="">
        <div class="d-flex flex-column flex-md-row justify-content-between mb-50px">
          <div class="logo-div d-flex flex-column gap-30">
            <img width="200" src="https://100trillions.com/modules/order/images/100T-Logo-2024-Gold.png" alt="" />
            <div class="d-flex gap-10">
              <img src="modules/order/images/buy-crypto-gold.svg" alt="" />
              <span>Congratulations! you earn {{ order?.earned_reward_transaction }} Points</span>
            </div>
          </div>

          <div class="invoice-details d-flex flex-column gap-10 align-items-end">
            <div class="d-flex align-items-end">
              <strong class="font-weight-bold mr-1">INVOICE</strong>
              <strong v-if="order.shopify_order_number" class="font-weight-bold"> #{{ order?.shopify_order_number
                }}</strong>
              <strong v-else class="font-weight-bold"> #L{{ order?.serial_number }}</strong>
            </div>
            <div class="d-flex flex-column align-items-end">
              <div class="">
                <span>{{ order?.created_at }}</span>
              </div>
              <div v-if="order?.total" class="d-flex gap-10 align-items-end">
                <span class="inline-label bolder">Grand Total:</span>
                <span class="value bolder">${{ currencyFormat(order?.total.amount, 0, 2) }} USD</span>
              </div>
            </div>
          </div>
        </div>

        <!--            second section-->
        <hr />
        <div class="second-section">
          <ShippingAddress class="border-right" :order="order" />
          <BillingAddress class="border-right" :order="order" />
          <div class="">
            <h6 class="font-weight-bold mb-3 text-md-right">100 Trillion, Inc</h6>
            <div class="bnw-row align-items-md-end">
              <span>18012 Cowan Suite 200</span>
              <span>Irvine, CA 92614</span>
              <span>United States</span>
              <span>+1-866-242-2154</span>
              <span>https://www.100trillions.com/</span>
            </div>
          </div>
        </div>
        <hr />
        <div class="second-section">
          <div class="border-right">
            <h6 class="font-weight-bold mb-3">Shipping method</h6>
            <span>{{ order?.shipping_method }}</span>
          </div>
          <div class="">
            <h6 class="font-weight-bold mb-3">Payment</h6>
            <span>{{ order?.payment_method }}</span>
          </div>
        </div>
        <hr />
        <div class="second-section">
          <div class="border-right">
            <h6 class="font-weight-bold mb-3">Fulfilment status</h6>
            <span>{{ order?.shipment_status }}</span>
          </div>
          <div class="">
            <h6 class="font-weight-bold mb-3">Payment Status</h6>
            <span>{{ order?.status }}</span>
          </div>
        </div>
        <hr />
        <OrderTable class="mt-2" :items="order?.productsTable" />
        <hr />
        <BillDetails class="mt-2" :order="order" :isDashboard="isDashboard" />
      </div>
      <div>
        <b-button variant="primary" @click="printInvoice">Print invoice</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import OrderTable from "./OrderTable.vue"
import BillDetails from "./BillDetails.vue"
import BillingAddress from "./BillingAddress.vue"
import ShippingAddress from "./ShippingAddress.vue"
import { currencyFormat } from "@core/helpers/configHelper"

export default {
  name: "Invoice",
  components: { ShippingAddress, BillingAddress, BillDetails, OrderTable },
  props: ["order", "isDashboard"],
  data() {
    return {
      printing: false
    }
  },
  methods: {
    currencyFormat,
    async printInvoice() {
      const printWindow = window.open("", "_blank")
      const invoiceDetailsContainer = document.getElementById("invoiceDetailsContainer").cloneNode(true)
      const head = document.head.cloneNode(true)

      const loadImage = (image) => {
        return new Promise((resolve, reject) => {
          if (image.complete) {
            resolve()
          } else {
            image.addEventListener("load", resolve)
            image.addEventListener("error", reject)
          }
        })
      }

      const loadStyleSheet = (link) => {
        return new Promise((resolve, reject) => {
          link.addEventListener("load", resolve)
          link.addEventListener("error", reject)
        })
      }

      const loadAllImages = (images) => {
        const imagePromises = Array.from(images).map(loadImage)
        return Promise.all(imagePromises)
      }

      const loadAllStyleSheets = (links) => {
        const stylesheetLinks = Array.from(links).filter(link => link.rel === "stylesheet")
        const styleSheetPromises = stylesheetLinks.map(loadStyleSheet)
        return Promise.all(styleSheetPromises)
      }

      const printFunction = () => {
        printWindow.print()
      }

      printWindow.document.head.innerHTML = head.innerHTML
      printWindow.document.body.innerHTML = invoiceDetailsContainer.outerHTML
      // printWindow.onafterprint = () => printWindow.close();

      await Promise.all([loadAllImages(printWindow.document.images), loadAllStyleSheets(printWindow.document.head.getElementsByTagName("link"))])
        .then(async () => {
          await this.$nextTick()
          printFunction()
        })
        .catch((error) => {
          console.error("Error loading resources:", error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.gap-20 {
  gap: 20px;
}

.gap-30 {
  gap: 30px;
}

.mb-50px {
  margin-bottom: 50px;
}

.bnw-row {
  display: flex;
  flex-direction: column;
  gap: 5px;

}

h6 {
  font-size: 18px;
}

.second-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: .5rem 0;
}

strong {
  font-size: 36px;
}

@media (max-width: 768px) {
  .second-section {
    grid-template-columns: repeat(1, 1fr);
  }

}

@media print {
  .print-container {
    position: relative;
  }
  .second-section {
    grid-template-columns: repeat(3, 1fr);
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .align-items-md-end {
    align-items: end !important;
  }
}

@media print {
  * {
    overflow: visible !important;
  }

}

</style>
